export const negation = (value: number, negate = true): number => {
  return negate ? -value : value
}
